module.exports = __webpack_public_path__ + "media/images/slide2-03b00062cdc47b26d736a2e805d89794.jpg";